<template>
	<div class="custom-container mx-auto">
		<a href="https://catalogo.riverosl.es" target="_blank">
			<img src="@/assets/images/banner/banner.png" class="w-100" />
		</a>
	</div>
</template>
